import { MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const regions = [
  { label: "Aachen", href: "/imagefilm-aachen" },
  { label: "Köln", href: "/imagefilm-koeln" },
  { label: "Düsseldorf", href: "/imagefilm-duesseldorf" },
  { label: "Bonn", href: "/imagefilm-aachen" },
  { label: "ganz NRW", href: "/imagefilm" },
];

/**
 * Small internal-linking strip that boosts city-page discoverability
 * and signals geographic focus.
 */
const RegionStrip = () => {
  return (
    <section aria-label="Standorte" className="py-8 md:py-10 border-t border-border/30">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 text-center">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <MapPin className="w-4 h-4 text-accent" />
            <span>Videoproduktion in:</span>
          </div>
          <ul className="flex flex-wrap items-center justify-center gap-x-2 gap-y-2 text-sm">
            {regions.map((r, i) => (
              <li key={r.label} className="flex items-center">
                <Link
                  to={r.href}
                  className="px-3 py-1.5 rounded-full border border-foreground/10 hover:border-accent/50 hover:text-accent transition-colors"
                >
                  {r.label}
                </Link>
                {i < regions.length - 1 && (
                  <span aria-hidden className="text-muted-foreground/30 mx-1 hidden md:inline">
                    ·
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default RegionStrip;
